/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import VerifyCustomer from 'dashboard/components/VerifyCustomer';
import validations from 'shared/helpers/validations';

const WelcomeDetailsInfo = ({ onChangeStep, customer, setCustomer, verificationsSteps }) => {
    const updateCustomerData = form => {
        let tempCustomer = {
            ...customer,
            firstName: form.firstName,
            lastName: form.lastName,
            phone: form.phone,
            organisation: form.organisation,
            customerType: form.customerType
        };
        if (tempCustomer.phone.charAt(0) === '0') {
            const changedPhoneNo = tempCustomer.phone.substring(1);
            tempCustomer = {
                ...tempCustomer,
                phone: `+44${changedPhoneNo}`
            };
        } else {
            console.log(tempCustomer.phone.charAt(0));
            if (form.phone.charAt(0) === '+') {
                tempCustomer = {
                    ...tempCustomer,
                    phone: `${tempCustomer.phone}`
                };
            } else {
                tempCustomer = {
                    ...tempCustomer,
                    phone: `+44${tempCustomer.phone}`
                };
            }
        }
        setCustomer({
            ...tempCustomer
        });
        onChangeStep(verificationsSteps[1]);
    };
    return (
        <Formik
            enableReinitialize
            initialValues={{
                firstName: customer.firstName,
                lastName: customer.lastName,
                phone: customer.phone,
                customerType: customer.customerType,
                organisation: customer.organisation,
                termsAgreed: customer.termsAgreed,
                address: {
                    ...customer.address
                }
            }}
            validationSchema={validations.InfoSchema}
            onSubmit={updateCustomerData}
            render={({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                setFieldValue
            }) => (
                <VerifyCustomer
                    firstName={values.firstName}
                    lastName={values.lastName}
                    phone={values.phone}
                    customerType={values.customerType}
                    organisation={values.organisation}
                    address={values.address}
                    errors={errors}
                    touched={touched}
                    submit={handleSubmit}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    isSubmitting={isSubmitting}
                    setFieldValue={setFieldValue}
                />
            )}
        />
    );
};

WelcomeDetailsInfo.propTypes = {
    onChangeStep: PropTypes.func.isRequired,
    customer: PropTypes.shape({
        onBoarding: PropTypes.bool,
        customerType: PropTypes.string,
        created_at: PropTypes.string,
        discount: PropTypes.number,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        organisation: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
        termsAgreed: PropTypes.bool,
        address: PropTypes.shape({
            addressLine1: PropTypes.string,
            addressLine2: PropTypes.string,
            townCity: PropTypes.string,
            postCode: PropTypes.string,
            country: PropTypes.string
        }),
        setCustomer: PropTypes.func
    }).isRequired,
    setCustomer: PropTypes.func.isRequired,
    verificationsSteps: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default WelcomeDetailsInfo;
